import React from 'react';

import { TextFieldProps, TextField } from '../TextField';

export type NumberFieldProps = TextFieldProps;

export function NumberField({ inputMode = 'numeric', type = 'number', ...restProps }: NumberFieldProps) {
  return <TextField {...restProps} inputMode={inputMode} type={type} />;
}
